import { render, staticRenderFns } from "./Classification.vue?vue&type=template&id=2f94ca07&scoped=true"
import script from "./Classification.vue?vue&type=script&lang=js"
export * from "./Classification.vue?vue&type=script&lang=js"
import style0 from "./Classification.vue?vue&type=style&index=0&id=2f94ca07&prod&lang=scss&scoped=true"
import style1 from "./Classification.vue?vue&type=style&index=1&id=2f94ca07&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f94ca07",
  null
  
)

export default component.exports